import AppIntegration from "./app-integration"

const AppsPage = () => {
    return (
        <AppIntegration />
    )
}

export default AppsPage